export class ProfileStrengthInfo {
    public profileStrength!: number;
    public profilePicStrengthPercentage!: number;
}